import { createContext, useContext, type ReactNode } from "react";
import { createPortal } from "react-dom";

/** The phone top bar's right end (the hamburger row), where a page can put its own controls. */
export const MobileTopBarSlot = createContext<HTMLElement | null>(null);

export function MobileTopBarPortal({ children }: { children: ReactNode }) {
  const slot = useContext(MobileTopBarSlot);
  return slot ? createPortal(children, slot) : null;
}
